import { Fragment } from "react";

export enum AVAILABILITY {
  "AVAILABLE" = "AVAILABLE",
  "NOT_AVAILABLE" = "NOT_AVAILABLE",
  "NEEDS_SELECTION" = "NEEDS_SELECTION",
}

export const AvailabilityDisplay = ({
  availability,
}: {
  availability: AVAILABILITY;
}) => {
  return (
    <Fragment>
      {availability === "AVAILABLE" && (
        <span>
          Dieses Produkt ist{" "}
          <strong className="text-green-600">aktuell lieferbar</strong>. Die
          Lieferzeit und Versandkosten sind abhängig von dem gewählten
          Versandort.
        </span>
      )}
      {availability === "NOT_AVAILABLE" && (
        <span>
          Dieses Produkt ist{" "}
          <strong className="text-red-600">aktuell nicht verfügbar</strong>.
          Versuch es später nochmal, um die Verfügbarkeit zu prüfen.
        </span>
      )}
      {availability === "NEEDS_SELECTION" && (
        <span>
          Bitte wähle eine Konfiguration aus, um die Verfügbarkeit zu prüfen.
        </span>
      )}
    </Fragment>
  );
};
